<template>
  <v-menu offset-y left>
    <v-btn slot="activator" flat>
      <v-icon color="gray-6">account_circle</v-icon>
      <span class="toolbar__button-label text-capitalize hidden-xs-only">
        {{ name }}
      </span>
      <v-icon color="gray-6" class="hidden-xs-only autocomplete__arrow" right small>keyboard_arrow_down</v-icon>
    </v-btn>

    <v-list class="v-list--custom">
      <v-list-tile v-if="claims && claims.user && claims.user['ROLE_POST_FORGOTPASSWORD']" @click="resetPassword">
        <v-list-tile-title>{{ $t('Common.resetPassword') }}</v-list-tile-title>
      </v-list-tile>

      <v-list-tile @click="logoutSession">
        <v-list-tile-title>{{ $t('Common.logout') }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import userService from '@/services/user'

export default {
  name: 'DropdownUser',
  computed: {
    ...mapState({
      claims: ({ userClaims }) => userClaims.claims,
      name: ({ session }) => session.user.business.name,
      email: ({ session }) => session.user.business.email
    })
  },
  methods: {
    ...mapActions({
      logout: 'session/logout',
      clearSelectedCompany: 'company/clearSelectedCompany',
      clearUserClaims: 'userClaims/clear',
      clearCostCenterCounter: 'costCenter/clear'
    }),

    async resetPassword () {
      const { commit } = this.$store

      try {
        await userService.forgotPassword(this.email)
        commit('snackbarAlert/success', this.$t('Views.LoginPage.sendEmailSuccess'))
      } catch (err) {
        console.log('Error', err)
        commit('snackbarAlert/error', this.$t('Common.genericError'))
      }
    },

    logoutSession () {
      this.logout()
      this.clearSelectedCompany()
      this.clearUserClaims()
      this.clearCostCenterCounter()

      if (window.Botkit) {
        window.removeEventListener('message', window.Botkit.receiveMessage, false)
      }
    }
  }
}
</script>
